import isObject from "lodash/isObject";
import isString from "lodash/isString";
import { DEFAULT_OPTION } from "./config";
import getMapEnums from "./getMapEnums";
import getObjectEnums from "./getObjectEnums";
import getOptionEnums from "./getOptionEnums";
import type { Config } from "../type";
import type { EnumItem } from "@/services/common/type";

export const batchPickPointedEnums = (
  configs: Config[] = [],
  enumsSource: Record<string, EnumItem[] | undefined>,
) => {
  const enums: Record<string, unknown> = {};

  configs.forEach((x) => {
    if (isString(x)) {
      const pointedEnum = enumsSource[x];
      enums[x] = getDiffFomartEnums(DEFAULT_OPTION, pointedEnum as EnumItem[]);
    } else if (isObject(x) && x.code) {
      const pointedEnum = enumsSource[x.code];
      enums[x.code] = getDiffFomartEnums(x, pointedEnum as EnumItem[]);
    }
  });

  return enums;
};

const getDiffFomartEnums = (config: Config, pointedEnum: EnumItem[]) => {
  const {
    keyFormat = DEFAULT_OPTION["keyFormat"],
    resFormat = DEFAULT_OPTION["resFormat"],
    omit = DEFAULT_OPTION["omit"],
    isAll = DEFAULT_OPTION["isAll"],
  } = config;
  switch (resFormat) {
    case "map":
      return getMapEnums({ keyFormat, omit, isAll }, pointedEnum);
    case "object":
      return getObjectEnums({ keyFormat, omit, isAll }, pointedEnum);
    case "option":
      return getOptionEnums({ keyFormat, omit, isAll }, pointedEnum);
  }
};
